"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButtonDialogBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Dialog_1 = require("./Dialog");
const constants_1 = require("../../constants");
const Paper_1 = require("../Paper");
const StyledClose = (0, styled_1.default)(Dialog_1.Dialog.Close) `
  position: absolute;
  top: ${constants_1.theme.spacing['4'] - 8}px;
  right: ${constants_1.theme.spacing['4'] - 8}px;
  padding: 2px;
`;
const CloseButtonDialogBody = ({ children, styles = {}, ...paperProps }) => {
    const stylesWithDefaults = {
        position: 'relative',
        p: 4,
        width: '100%',
        maxWidth: 600,
        ...styles,
    };
    return ((0, jsx_runtime_1.jsxs)(Paper_1.Paper, { as: Dialog_1.Dialog.Panel, ...paperProps, styles: stylesWithDefaults, children: [children, (0, jsx_runtime_1.jsx)(StyledClose, {})] }));
};
exports.CloseButtonDialogBody = CloseButtonDialogBody;
